module.exports = __webpack_public_path__ + "img/cursor-click-01.5e433735.svg";